import script from "./DlcSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DlcSection.vue?vue&type=script&setup=true&lang=js"

import "./DlcSection.vue?vue&type=style&index=0&id=6fc8ef26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc8ef26"]])

export default __exports__